import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, FileText, FolderOpen } from 'lucide-react';
import { tutorialAPI } from '@/utils/tutorialApi';
import { buildManualNodePath } from '@/config/ipeRoutes';

function formatDate(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('zh-CN', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function TutorialManualHomePage() {
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await tutorialAPI.getTree();
        if (!cancelled) setTree(data?.tree || []);
      } catch {
        if (!cancelled) setTree([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="tutorial-page">
      <div className="tutorial-page__hero">
        <h1>IPE 使用手册</h1>
        <p>按工作台实际功能模块编写：智能工具各子功能、IPE 设计器、工作流、上架管理与空间。每个模块一篇详细操作说明。</p>
      </div>

      {loading ? (
        <p className="tutorial-manual__empty">加载中…</p>
      ) : (
        <div className="tutorial-home-grid">
          {tree.map((section) => (
            <section key={section.id} className="tutorial-home-card">
              <div className="tutorial-home-card__head">
                <FolderOpen size={18} />
                <h2>{section.title}</h2>
              </div>
              <div className="tutorial-home-card__links">
                {(section.children || []).slice(0, 6).map((item) => (
                  <Link key={item.id} to={buildManualNodePath(item.slug)} className="tutorial-home-card__link">
                    {item.nodeType === 'FOLDER' ? <FolderOpen size={14} /> : <FileText size={14} />}
                    <span>{item.title}</span>
                    <ChevronRight size={14} />
                  </Link>
                ))}
                <Link to={buildManualNodePath(section.slug)} className="tutorial-home-card__more">
                  查看全部分类
                </Link>
              </div>
              <p className="tutorial-home-card__meta">最近更新 {formatDate(section.updatedAt)}</p>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
